<div>
  <button matIconButton
          [ezPreventMultiClick]="setPositiveFeedback">
    <mat-icon matTooltip="Love this"
              small
              [class.outlined]="userRating() !== conversationUserRatingType.ThumbsUp"
              color="primary">thumb_up</mat-icon>
  </button>
  <button matIconButton
          [ezPreventMultiClick]="setNegativeFeedback">
    <mat-icon matTooltip="Needs improvement"
              small
              [class.outlined]="userRating() !== conversationUserRatingType.ThumbsDown"
              color="primary">thumb_down</mat-icon>
  </button>
</div>